import {readSupportedInstitutions} from "../data/processors/en-US-processor";
import React from "react";

export class Institutions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inst_list: readSupportedInstitutions(),
            filterText: ''
        }
    }

    getSupportedInstitutions = () => {
        readSupportedInstitutions()
    }

    filter = (event) => {
        let enteredText = event.target.value.toUpperCase();
        this.setState({ filterText: enteredText })
    }

    render() {
        const { inst_list, filterText } = this.state;

        return (
            <div className={"ui centered card"}>
                <div className={"ui input"}>
                    <input type={"text"} placeholder={"Search ..."} onChange={(event) => this.filter(event)}>
                    </input>
                </div>
                <div className={"ui middle aligned selection list"}>
                    {
                        inst_list.filter(inst => inst.toUpperCase().includes(filterText)).map(inst => (
                            <div className={"item"}>
                                <div className={"content"}>
                                    <div className={"header"}>{inst}</div>
                                </div>
                            </div>
                        ))
                    }
                </div>
                <div className={"ignored ui info centered message"}> Don't see your institution ? <a href={"/contact"}> <b>Drop us a message</b> </a>, and we'll add it in a few days !</div>
            </div>

        )
    }
}